<template>
    <el-dialog title="实战合同存档"
               :visible.sync="hetongShow"
               width="80%">
        <div class="lottery">
            <span v-for="(item, index) in lottery.arr"
                  :key="index"
                  :class="lottery.active == index?'active':''"
                  @click="lottery.active = index">{{item}}</span>
            <div class="msg">实战合同存档</div>
        </div>
        <el-table>
            <el-table-column label="序号"></el-table-column>
            <el-table-column label="彩票投注站"></el-table-column>
            <el-table-column label="彩票投编号"></el-table-column>
            <el-table-column label="众筹详情"></el-table-column>
            <el-table-column label="兑奖支出明细"></el-table-column>
            <el-table-column label="现任彩票代表和彩票经理"></el-table-column>
            <el-table-column label="帮扶合同四件套"></el-table-column>
        </el-table>

        <div class="fenye">
            <span class="zhanwei"></span>
            <el-pagination background
                           layout="prev, pager, next"
                           :total="1000">
            </el-pagination>
            <div>自定义期号<input type="text" /><span>搜索</span></div>
        </div>

    </el-dialog>
</template>

<script>
export default {
    data () {
        return {
            hetongShow: false,
            lottery: {
                arr: ['双色球', '大乐透'],
                active: 0,
            },

        }
    }
}
</script>

<style lang="scss" scoped>
.lottery {
    border: 1px solid rgba(0, 0, 0, 0.2);
    position: relative;
    span {
        background-color: #dbdbdb;
        padding: 20px 70px;
        display: inline-block;
        cursor: pointer;
        &.active {
            background-color: #ffffff;
        }
    }
    .msg {
        color: #951d1d;
        position: absolute;
        right: 10px;
        bottom: 4px;
        font-weight: bold;
        font-size: 40px;
    }
}
</style>